module.exports = __webpack_public_path__ + "img/btn_bet_size.e3a4415c.png";